import React from "react";
import "./ModalContentCenter.css";

interface ModalContentCenterProps {
  visible: boolean;
  children?: React.ReactNode;
}

const ModalContentCenter: React.FC<ModalContentCenterProps> = ({ visible, children }) => {
  if (!visible) return null;
  return (
    <>
      <div className="modal-center-dialog">{children}</div>
      <div className="modal-center-overlay"></div>
    </>
  );
};

export default ModalContentCenter;
